export const environment = {
  production: true,
  adobeApiKey: '16ceeb6cce1a46aea1b82c9fe1527ee9',
  api: {
    root: 'https://ivalves-prod-api.azurewebsites.net/ValveAdmin',
  },
};
